<app-ginop-header [title]="title" [subTitle]="subTitle" [image]="image"></app-ginop-header>

<section class="ginop-details">
  <div *ngIf="thematicIcon && thematicIcon.value" class="specicon {{ thematicIcon.value.key }}"></div>

  <div *ngIf="country || city || date || deadline" class="ginop-details-loc-date">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div *ngIf="country || city" class="detail">
            <div class="detail-label loc-label">Location</div>
            <div class="info">
              <ng-container *ngIf="country">{{ country }},</ng-container>
              <ng-container *ngIf="city">{{ city }}</ng-container>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div *ngIf="date" class="detail">
            <div class="detail-label date-label">Date</div>
            <div class="info">{{ date | dateFormat }}</div>
          </div>
        </div>
        <div class="col-md-4">
          <div *ngIf="deadline" class="detail">
            <div class="detail-label deadline-label">Deadline</div>
            <div class="info">{{ deadline | dateFormat }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <a [routerLink]="['/', 'b2b-events']" class="back-to">back to the events</a>

    <div *ngIf="(agendaList && agendaList.length) || information" class="ginop-details-program">
      <h2 class="program-title">Program</h2>
      <span *ngIf="agendaSubtitle" class="program-subtitle">{{ agendaSubtitle }}</span>
      <div class="program-row-wrapper">
        <div class="program-row" *ngFor="let agenda of agendaList">
          <div *ngIf="agenda.from" class="program-time">
            <span>{{ agenda.from }}</span>
            <span>-</span>
            <span *ngIf="agenda.to">{{ agenda.to }}</span>
          </div>
          <div *ngIf="agenda.text" [innerHTML]="agenda.text" class="program-part"></div>
        </div>
      </div>

      <div class="programs-label">*The organizers reserve the right to change the program.</div>
      <div *ngIf="information" class="information">
        <h2 class="info-title">Information</h2>
        <div class="info-text" [innerHTML]="information"></div>
      </div>
    </div>

    <div *ngIf="venueInformation" class="venue-parking">
      <h4>Venue information</h4>
      <p [innerHTML]="venueInformation"></p>
    </div>

    <div *ngIf="parkingPossibilities" class="venue-information">
      <h4>Parking possibilities</h4>
      <p [innerHTML]="parkingPossibilities"></p>
    </div>

    <a
      [href]="'https://maps.google.com/?q=' + lat + ',' + long"
      *ngIf="lat && long"
      target="_blank"
      class="button button-primary"
      [appBackgroundColor]="'red'"
      >Route planner</a
    >
  </div>

  <div *ngIf="exhibitorList && exhibitorList.length" class="exhibitors">
    <h2 class="exhibitors-title">Exhibitors</h2>

    <div *ngFor="let exhibitor of exhibitorList" class="exhibitor-card">
      <span
        *ngIf="exhibitor?.image?.value"
        [style.background-image]="'url(' + exhibitor.image.value.url + ')' | ssrEmptyString"
        [attr.aria-label]="exhibitor?.image?.value?.image?.title"
        class="exhibitor-logo"
        role="img"
      ></span>
      <div *ngIf="exhibitor.title || exhibitor.text" class="exhibitor-description">
        <h5 *ngIf="exhibitor.title" class="exhibitor-card-title">{{ exhibitor.title }}</h5>
        <p *ngIf="exhibitor.text" [innerHTML]="exhibitor.text"></p>
      </div>
    </div>
  </div>

  <div class="details-registration">
    <h3 class="details-registration-title">Registration form</h3>
    <p>Complete the application form, please choose from the options below</p>
    <div class="registration-links">
      <a [routerLink]="[url, 'participant']" [class.inactive]="!isParticipantRegActive" class="button button-secondary">Participant</a>
      <a [routerLink]="[url, 'exhibitor']" [class.inactive]="!isExhibitorRegActive" class="button button-secondary">EXHIBITOR (HU)</a>
    </div>
  </div>
</section>
